// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aqw0eA7nQemubCqVcHcl{flex-direction:column;justify-content:center;align-items:center;gap:16px;width:100%;height:100%;display:flex}.jaLy2QvlPuwwMm3QygsE{align-items:center;height:32px;padding-left:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `Aqw0eA7nQemubCqVcHcl`,
	"wrapLabel": `jaLy2QvlPuwwMm3QygsE`
};
export default ___CSS_LOADER_EXPORT___;
